
export default {
  props: {
    color: {
      default: "#363636"
    },
    size: {
      default: "16px"
    }
  }
};
